const contactStyles = {
  section: {
    background: "#1f2a2a",
    minHeight: "100vh",
  },
  container: {
    minHeight: "100vh",
    padding: "3rem 1.5rem",
  },
  grid: {
    maxWidth: 1100,
  },
  overline: {
    color: "tan",
    letterSpacing: "0.3em",
  },
  heading: {
    color: "#f1e3c8",
    fontWeight: 700,
    marginTop: "0.5rem",
    marginBottom: "1rem",
  },
  summary: {
    color: "#c8c1b3",
    maxWidth: 520,
    lineHeight: 1.6,
  },
  languagesWrap: {
    marginTop: "2rem",
  },
  languageLabel: {
    color: "tan",
    letterSpacing: "0.2em",
  },
  chipRow: {
    display: "flex",
    gap: "0.75rem",
    marginTop: "0.75rem",
    flexWrap: "wrap",
  },
  chip: {
    color: "#fff",
  },
  card: {
    border: "1px solid #3b4a47",
    padding: "2rem",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: "1.5rem",
    alignItems: "center",
    "@media (max-width:600px)": {
      gridTemplateColumns: "1fr",
      justifyItems: "center",
      textAlign: "center",
      padding: "1.25rem",
    },
  },
  avatar: {
    width: 140,
    height: 140,
    borderRadius: "50%",
    objectFit: "cover",
    background: "#2a3836",
    "@media (max-width:600px)": {
      width: 110,
      height: 110,
    },
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
  },
  actionRow: {
    display: "flex",
    gap: "0.75rem",
    width: "100%",
  },
  actionButton: {
    justifyContent: "flex-start",
    color: "#f1e3c8",
    borderColor: "#f1e3c8",
    width: "100%",
  },
  actionButtonDisabled: {
    "&.Mui-disabled": {
      color: "#f1e3c8",
      borderColor: "#f1e3c8",
      opacity: 1,
    },
  },
};

export default contactStyles;
